// extracted by mini-css-extract-plugin
module.exports = {"endCard":"styles_endCard__DoqaD","courseCardWrapper":"styles_courseCardWrapper__2Cggb"};